import { addLog } from 'assets/components/feedback/Feedback';
import ModalForm from 'assets/components/form/modalForm/ModalForm';
import ThemeModalFormDefault from 'assets/components/form/modalForm/themes/Theme.ModalForm.Default';
import FileInput from 'assets/components/inputs/file/FileInput';
import ThemeFileInputDropzone from 'assets/components/inputs/file/themes/Theme.FileInput.Dropzone';
import FormWrapper from 'assets/components/inputs/wrappers/FormWrapper';
import { getLocales } from 'assets/locales/Locale';
import { combineStrings } from 'assets/utils/data/String';
import { HttpStatus } from 'config/Api.Config';
import { difference } from 'lodash';
import statementBalanceDeleteFileApi from 'models/sales/statementsBalance/deleteFile/Api.StatementBalance.DeleteFile';
import statementBalanceUploadFileApi from 'models/sales/statementsBalance/uploadFile/Api.StatementBalance.UploadFile';
import { useStatementBalanceProvider } from '../StatementBalance.Hooks';

export type StatementBalanceForm = Omit<Api.Core.StatementBalance.Save.IRequest, 'statementDocuments'> & {
  files: Hooks.Input.File.Info[];
};

export default function StatementBalanceUploadDocuments() {
  const { lang } = getLocales();
  const { pageRouter, selected, listApi } = useStatementBalanceProvider();

  return (
    <ModalForm<StatementBalanceForm>
      subcomponents={ThemeModalFormDefault}
      title={lang.documentUpload}
      default={{
        files: selected?.mediaFiles?.map((it) => ({
          id: it.id,
          dataUrl: it.url,
          name: it.name,
          type: it.contentType as Utils.File.MimeType,
        })),
      }}
      onCancel={pageRouter.updateParams}
      onSubmit={async ({ files }) => {
        let totalFiles = 0;
        let uploadedFiles = 0;
        let deletedFiles = 0;
        let totalDeletedFiles = 0;
        const deletedFileIds = difference(
          selected?.mediaFiles?.map((it) => it.id),
          files?.map((it) => it.id)
        );
        for (const fileId of deletedFileIds || []) {
          const fileUploadResponse = await statementBalanceDeleteFileApi(selected?.id, {
            fileId,
          });
          if (fileUploadResponse.status === HttpStatus.ok) {
            deletedFiles += 1;
          }
          totalDeletedFiles += 1;
        }
        for (const formFile of files?.filter((it) => !it.id && it.original) || []) {
          const fileUploadResponse = await statementBalanceUploadFileApi(selected?.id, {
            formFile: formFile.original,
          });
          if (fileUploadResponse.status === HttpStatus.ok) {
            uploadedFiles += 1;
          }
          totalFiles += 1;
        }
        listApi.execute((body) => body);
        if (uploadedFiles !== totalFiles || deletedFiles !== totalDeletedFiles) {
          addLog({
            warning: combineStrings(
              ' ',
              lang.formSuccessAndFilesFailedMessage,
              totalFiles > 0 ? `${uploadedFiles}/${totalFiles} ${lang.filesUploaded}` : null,
              totalDeletedFiles > 0 ? `${deletedFiles}/${totalDeletedFiles} ${lang.filesGotDeleted}!` : null
            ),
          });
        } else {
          addLog({ success: lang.saveSuccess });
        }
      }}
      render={({ form }) => (
        <FormWrapper>
          <FileInput
            name="files"
            label={lang.documents}
            value={form.data?.files || []}
            onChange={form.update}
            class={ThemeFileInputDropzone}
          />
        </FormWrapper>
      )}
    />
  );
}
